<template>
	<div :class="[scannerClass, 'half-width']">
		<div class="pb-6 pr-[24px]">
			<h3 :class="[titleClass, 'text-left']">{{ title }}</h3>
			<p :class="[paragraphClass, 'pt-3 text-left']">{{ description }}</p>
			<CtaButton
				class="pt-[24px] !text-left"
				:height="buttonHeight"
				:to="buttonLink"
				:button-class="buttonClass"
				:type="buttonType || 'gradient-dark'"
				:blank="true"
				:data-cta-type="dataCtaType"
			>
				{{ buttonText || "View Pricing" }}
			</CtaButton>
		</div>
		<img
			:id="imgId"
			data-animate="true"
			class="scanner-small-img"
			:src="imgSrc"
			:alt="imgAlt"
			:width="imgWidth"
			:height="imgHeight"
			loading="lazy"
		/>
	</div>
</template>

<script setup>
const props = defineProps([
	"scannerClass",
	"titleClass",
	"paragraphClass",
	"title",
	"description",
	"buttonHeight",
	"buttonLink",
	"buttonClass",
	"buttonType",
	"buttonText",
	"imgId",
	"imgSrc",
	"imgAlt",
	"imgWidth",
	"imgHeight",
	"dataCtaType"
]);
</script>
<style lang="scss" scoped>
.scanner-title {
	font-family: Open Sauce Sans;
	font-size: 32px;
	font-weight: 500;
	letter-spacing: -2px;
	line-height: 35px;
	text-align: left;
}
</style>
